import { businessIsAllowedToSeeFeature } from '@/router/validators/utils/businessIsAllowedToSeeFeature';
import { ValidatorState } from '../types';

export function socialRewardsValidator(): ValidatorState {
  let disclaimersKeys: Array<string> = [];
  const isValid = businessIsAllowedToSeeFeature('online');

  return {
    isValid,
    disclaimersKeys
  };
}
